var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"me-2",staticStyle:{"border-radius":"6px"},style:(`background-color: ${_vm.color.includes('#') ? _vm.color : '#' + _vm.color}; height: ${_vm.size}px; width: ${_vm.size}px; `)})
}
var staticRenderFns = []

export { render, staticRenderFns }